import { OpenAPI } from "simplydo/interfaces";

import SearchParams from "../searchParams";

export const superadmin = (api) => ({
  getSuperadmins(
    success: (data: OpenAPI.GET<"/superadmin/users">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("GET", "/superadmin/users", null, success, fail);
  },
  evaluateScript(
    data: OpenAPI.POST<"/superadmin/scripts/execute">["requestBody"],
    success: (
      data: OpenAPI.POST<"/superadmin/scripts/execute">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/scripts/execute",
      data,
      success,
      fail,
    );
  },
  getScript(
    term,
    success: (data: OpenAPI.GET<"/superadmin/scripts">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/superadmin/scripts?query=${term || ""}`,
      null,
      success,
      fail,
    );
  },
  createScript(
    data: OpenAPI.POST<"/superadmin/scripts">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/scripts">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/scripts",
      data,
      success,
      fail,
    );
  },
  editScript(
    id: string,
    data: OpenAPI.POST<"/superadmin/scripts/{id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/superadmin/scripts/{id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/superadmin/scripts/${id}`,
      data,
      success,
      fail,
    );
  },
  deleteScript(
    id: string,
    success: (
      data: OpenAPI.DELETE<"/superadmin/scripts/{id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/superadmin/scripts/${id}`,
      null,
      success,
      fail,
    );
  },
  genData(
    data: OpenAPI.POST<"/superadmin/gen/data">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/gen/data">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/gen/data",
      data,
      success,
      fail,
    );
  },
  removeGenData(
    success: (data: OpenAPI.DELETE<"/superadmin/gen/data">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      "/superadmin/gen/data",
      null,
      success,
      fail,
    );
  },
  sendEmail(
    data: OpenAPI.POST<"/superadmin/email">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/email">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("POST", "/superadmin/email", data, success, fail);
  },
  getApiQuota(
    success: (data: OpenAPI.GET<"/superadmin/api">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("GET", "/superadmin/api", null, success, fail);
  },
  forceCrash(
    data: OpenAPI.POST<"/superadmin/developers/crash">["requestBody"],
    success: (
      data: OpenAPI.POST<"/superadmin/developers/crash">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/developers/crash",
      data,
      success,
      fail,
    );
  },
  getGlobalSettings(
    success: (data: OpenAPI.GET<"/superadmin/settings">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      "/superadmin/settings",
      null,
      success,
      fail,
    );
  },
  updateGlobalSettings(
    data: OpenAPI.POST<"/superadmin/settings">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/settings">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/settings",
      data,
      success,
      fail,
    );
  },
  allChallenges(
    params: OpenAPI.GET<"/superadmin/challenges">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/challenges">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/challenges?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  allIdeas(
    params: OpenAPI.GET<"/superadmin/ideas">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/ideas">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/ideas?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  getAnalytics(
    params: OpenAPI.GET<"/superadmin/analytics">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/analytics">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/analytics?${queryParams}`,
      null,
      success,
      fail,
    );
  },
});
